//export const API_URL: string = "http://192.168.1.191:8888/askmarc-backend/api";

//PROD APP
export const APP_URL: string = "https://ask-marc.net";

//TEST APP
//export const APP_URL: string = "https://askmarc.ci-app.com";

//PROD/TEST API
export const API_URL: string = APP_URL + "/backend/api";

// DEV
// export const APP_URL: string = "http://localhost:8100/";
// export const API_URL: string = "http://127.0.0.1:8888/askmarc-backend/api";



// WEBPACK FOOTER //
// ./src/providers/api-url.ts